import React from "react";
import { HuidigeSituatieInkomen } from "../../../../.generated/rapportage/rapportagetypes";
import { InkomensLoondienstTable } from "./inkomens-loondienst-table";
import { InkomensOndernemingTable } from "./inkomens-onderneming-table";
import { InkomensStelpostenTable } from "./inkomens-stelposten-table";

export interface InkomensTableProps {
  data: HuidigeSituatieInkomen;
}

export const InkomensTable: React.FC<InkomensTableProps> = ({
  data,
}: InkomensTableProps) => {
  return (
    <div className="inkomens-section">
      {data.inkomensLoondienst && data.inkomensLoondienst.length > 0 && (
        <div className="mb-4">
          <InkomensLoondienstTable data={data.inkomensLoondienst} />
        </div>
      )}

      {data.inkomensOnderneming && data.inkomensOnderneming.length > 0 && (
        <div className="mb-4">
          <InkomensOndernemingTable data={data.inkomensOnderneming} />
        </div>
      )}

      {/* Box 1 Stelposten */}
      {(data as any).inkomensOverigBox1 &&
        (data as any).inkomensOverigBox1.length > 0 &&
        (data as any).inkomensOverigBox1[0].stelposten &&
        (data as any).inkomensOverigBox1[0].stelposten.length > 0 && (
          <InkomensStelpostenTable
            data={(data as any).inkomensOverigBox1[0].stelposten}
            title="Inkomsten box 1"
          />
        )}

      {/* Box 3 Stelposten */}
      {(data as any).inkomensOverigBox3 &&
        (data as any).inkomensOverigBox3.length > 0 &&
        (data as any).inkomensOverigBox3[0].stelposten &&
        (data as any).inkomensOverigBox3[0].stelposten.length > 0 && (
          <InkomensStelpostenTable
            data={(data as any).inkomensOverigBox3[0].stelposten}
            title="Inkomsten box 3"
          />
        )}
    </div>
  );
};
